export default "__VITE_PUBLIC_ASSET__da91d6b5__"